import React from 'react'
import { Chip, ChipProps } from '@mui/material'
import { CardGiftcardRounded } from '@mui/icons-material'

export type SubscriptionStatus =
  | 'active'
  | 'inactive'
  | 'expired'
  | 'expiring'
  | 'failed'
  | 'completed'
  | 'success'
  | 'gifted'
  | 'test'
  | 'pending'

const CHIP_STYLES: Record<
  SubscriptionStatus,
  { label: string; dot?: string; icon?: boolean; bg: string; text: string }
> = {
  active: { label: 'Active', dot: '#0A8F52', bg: '#E8FFF3', text: '#0A8F52' },
  inactive: { label: 'Inactive', dot: '#888', bg: '#F4F4F4', text: '#888' },
  expired: { label: 'Expired', dot: '#888', bg: '#F4F4F4', text: '#888' },
  expiring: { label: 'Expiring', dot: '#F9A825', bg: '#FFF8E1', text: '#F9A825' },
  failed: { label: 'Failed', dot: '#C62828', bg: '#FEEBEE', text: '#C62828' },
  completed: { label: 'Completed', dot: '#0A8F52', bg: '#E8FFF3', text: '#0A8F52' },
  success: { label: 'Completed', dot: '#0A8F52', bg: '#E8FFF3', text: '#0A8F52' },
  gifted: { label: 'Gifted', icon: true, bg: '#E3F2FD', text: '#1565C0' },
  test: { label: 'Admin Test', bg: '#E3F2FD', text: '#1565C0' },
  pending: { label: 'Pending', dot: '#F9A825', bg: '#FFF8E1', text: '#F9A825' },
}

interface SubscriptionChipProps extends Omit<ChipProps, 'label' | 'icon'> {
  status: string
}

export const SubscriptionChip = ({
  status,
  sx,
  size = 'small',
  ...rest
}: SubscriptionChipProps) => {
  const s = CHIP_STYLES[status as SubscriptionStatus] ?? CHIP_STYLES.active

  return (
    <Chip
      label={<span style={{ display: 'flex', alignItems: 'center' }}>{s.label}</span>}
      size={size}
      variant="outlined"
      sx={{
        backgroundColor: s.bg,
        color: s.text,
        fontWeight: 600,
        border: 'none',
        ...sx,
      }}
      {...rest}
    />
  )
}
